import { render, staticRenderFns } from "./eveningcounselling.vue?vue&type=template&id=278a90ee&"
import script from "./eveningcounselling.vue?vue&type=script&lang=js&"
export * from "./eveningcounselling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports